import {
  showMessage,
  SNACKBAR_MESSAGE_SEVERITY_ERROR,
  SNACKBAR_MESSAGE_SEVERITY_SUCCESS,
  SNACKBAR_MESSAGE_SEVERITY_WARNING
} from "../../hocs/snackbar-provider";
import {REQUEST_ERROR, REQUEST_INIT, REQUEST_SUCCESS} from "../request/requestActions";
import {
  clearUser,
  USER_EMAIL_CONFIRMATION_SUBMIT,
  USER_PASSWORD_CHANGE,
  USER_PASSWORD_SET,
  USER_RESET_PASSWORD_EMAIL_SEND
} from "../../state/user/userActions";
import {USERS_CONFIG_USER_CREATE} from "../../state/users-config/usersConfigActions";

const userMiddlewareFactory =
  t =>
  ({dispatch, getState}) =>
  next =>
  action => {
    const state = getState();

    // if a request is starting but auth token is expired
    if (
      action.type === REQUEST_INIT &&
      state.user.isAuthenticated &&
      state.user.tokenReceivedTime !== null &&
      state.user.tokenTTL !== null &&
      (new Date().getTime() - state.user.tokenReceivedTime) / 1000 / 60 >= state.user.tokenTTL
    ) {
      showMessage(t("middlewares.user.sessionExpired"), SNACKBAR_MESSAGE_SEVERITY_WARNING);
      dispatch(clearUser());
    }

    // if sent token is expired
    if (action.payload?.extra?.responseHeaders && action.payload.extra.responseHeaders["token-expired"]) {
      showMessage(t("middlewares.user.sessionExpired"), SNACKBAR_MESSAGE_SEVERITY_WARNING);
      dispatch(clearUser());
    }

    if (
      action.type === REQUEST_SUCCESS &&
      (action.payload.label === USER_PASSWORD_CHANGE || action.payload.label === USER_PASSWORD_SET) &&
      action.payload?.response?.haveError !== true
    ) {
      showMessage(t("middlewares.user.passwordChangedLoginNecessary"), SNACKBAR_MESSAGE_SEVERITY_WARNING);
    } else if (action.type === REQUEST_SUCCESS && action.payload.label === USER_RESET_PASSWORD_EMAIL_SEND) {
      showMessage(t("middlewares.user.resetPasswordEmailSent"), SNACKBAR_MESSAGE_SEVERITY_SUCCESS);
    } else if (
      action.type === REQUEST_SUCCESS &&
      action.payload.label === USERS_CONFIG_USER_CREATE &&
      !action.payload.response.haveError &&
      action.payload.extra?.isAnonymous
    ) {
      showMessage(t("middlewares.user.userRegisterSubmit"), SNACKBAR_MESSAGE_SEVERITY_SUCCESS);
    } else if (
      action?.payload?.label === USER_EMAIL_CONFIRMATION_SUBMIT &&
      (action.type === REQUEST_ERROR || (action.type === REQUEST_SUCCESS && action.payload.response.haveError))
    ) {
      showMessage(t("middlewares.user.emailConfirmationError"), SNACKBAR_MESSAGE_SEVERITY_ERROR);
    }

    return next(action);
  };

export default userMiddlewareFactory;
